const API_URL = process.env.REACT_APP_API_URL;

let apiUrls = {
    elements: `${API_URL}/affix-elements`,
    saveDiscountTable: `${API_URL}/affix-element/save-discount-table`
};

export default apiUrls;
